const environment = { prod: true, sentryDSN: 'https://e590736116b94b5997dd5d93db3c7f9e@pharos.arcpublishing.com/7' };
export { environment as default };
